/**
 * Represents the options selected by the user when importing data.
 */
export class ImportOptions {
   public importCallers: boolean;
   public importCallpoints: boolean;
   public originalProjectCopyId: number = -1;
   public originalProjectId: number = -1;
   public tempProjectId: number = -1;
}